module.exports = __webpack_public_path__ + "6afd6402544c9e79ae6fd563d42dba5a.gif";